"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouter = require("react-router");
var _NavBarModule = _interopRequireDefault(require("./NavBar.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NavbarLink = props => {
  const {
    label,
    openInNewTab,
    to
  } = props;
  return /*#__PURE__*/_react.default.createElement(_reactRouter.NavLink, {
    children: label,
    to: to,
    target: openInNewTab ? "_blank" : "",
    rel: openInNewTab ? "noreferrer noopener" : "",
    className: _NavBarModule.default.navLink
  });
};
NavbarLink.propTypes = {
  activeLinks: _propTypes.default.arrayOf(_propTypes.default.string),
  label: _propTypes.default.string,
  openInNewTab: _propTypes.default.bool,
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
};
var _default = exports.default = NavbarLink;